// removed by extract-text-webpack-plugin
module.exports = {"assetManagementContainer":"src-pages----asset-management-module---assetManagementContainer---xxCiU","stdContent":"src-pages----asset-management-module---stdContent---3djal","left":"src-pages----asset-management-module---left---3dUvt","right":"src-pages----asset-management-module---right---b5SbD","section":"src-pages----asset-management-module---section---3SOFu","callout":"src-pages----asset-management-module---callout---2l7Fm"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/asset-management.module.less
// module id = 271
// module chunks = 207213880550192